$(function () {

    function pushProductSelectorConfiguratorCompleteEvent(productApplicationJson) {
        try {
            if (productApplicationJson) {
                var productApplication = JSON.parse(productApplicationJson);
                if (productApplication) {
                    var vehicle = productApplication.Vehicle;
                    var product = productApplication.Product;
                    var components = product.Components;

                    var productClassFacet = product.ProductFacets?.find(facet => facet.Name?.trim() === 'Product Class');
                    var productCategoryFacet = product.ProductFacets?.find(facet => facet.Name?.trim() === 'Product Category');
                    var productFamilyFacet = product.ProductFacets?.find(facet => facet.Name?.trim() === 'Product Family');
                    var price = getPriceFromComponents(components);

                    var componentsData = components.map(component => {

                        return {
                            'item_id': component.Item?.ItemNumber ?? '',
                            'item_name': component.Item?.EnhancedDescription ?? component.Item?.Description ?? '',
                            'item_brand': 'BOSS',
                            'item_category': productClassFacet?.Value ?? '',
                            'item_category2': productCategoryFacet?.Value ?? '',
                            'item_category3': productFamilyFacet?.Value ?? '',
                            'item_category4': component.ComponentType?.Name ?? '',
                            'price': component.Item?.ListPrice ?? 0,
                        }

                    });

                    var vehicleSpecsData = generateVehicleSpecs(vehicle.Specs ?? []);

                    var analyticsData = {
                        'event': 'configurator_complete',
                        'configurator_type': 'product_selector',

                        'product_type': product.ProductType?.Name ?? '',
                        'vehicle_type': vehicle.VehicleType?.Name ?? '',
                        ...vehicleSpecsData,

                        'recommended_product_name': product.ProductName,

                        'ecommerce': {
                            'currency': 'USD',
                            'value': price,
                            'items': componentsData
                        }
                    };

                    if (analyticsData) {
                        dataLayer.push({ event: 'gtm.clear' });
                        dataLayer.push(analyticsData);
                    }
                }
            }
        } catch (error) {
            console.error('Error pushing product selector configurator complete event:', error);    
        }
    }

    function generateVehicleSpecs(specs) {
    var specsData = {};
        specs.forEach(spec => {
           specsData[`vehicle_${spec.SpecName?.toLowerCase() ?? ''}`] = spec.Value ?? '';
        });
        return specsData;
    }

    function getPriceFromComponents(components) {
        var totalPrice = 0;
        components.forEach(component => {
            totalPrice += component.Item?.ListPrice ?? 0;
        });
        return totalPrice;
    }

    function trackProductSelectorConfiguratorCompleteEvent() {
        var selectorSection = $("#selector-section");
        if (selectorSection && selectorSection.length > 0) {
            var productApplication = selectorSection[0].dataset.selectedProductApplication;
            pushProductSelectorConfiguratorCompleteEvent(productApplication);
        }
    }

    window.trackProductSelectorConfiguratorCompleteEvent = trackProductSelectorConfiguratorCompleteEvent;
});